function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import angular from 'angular';
import { AccesoDatos } from 'src/_candidato/comun/services/acceso-datos';
import { BaseFeaturesComponent } from '../_base/base-features.component';
import { chunk } from 'lodash';
var PanelCoincidenciasHistoricComponentCtrl = /*#__PURE__*/function (_BaseFeaturesComponen) {
  PanelCoincidenciasHistoricComponentCtrl.$inject = ["$log", "$timeout", "AccesoDatos", "appConfigService"];
  function PanelCoincidenciasHistoricComponentCtrl($log, $timeout, AccesoDatos, appConfigService) {
    var _this;
    _classCallCheck(this, PanelCoincidenciasHistoricComponentCtrl);
    _this = _callSuper(this, PanelCoincidenciasHistoricComponentCtrl, [appConfigService]);
    _defineProperty(_this, "filtroHist", {
      value: null,
      nregs: 20,
      npage: 0,
      lote: 10,
      lotePend: 10,
      noBuscarPend: false
    });
    _defineProperty(_this, "loteActual", '');
    _defineProperty(_this, "lotePendActual", '');
    _defineProperty(_this, "listado", {
      valido: false,
      list: []
    });
    _defineProperty(_this, "panelcv", {
      $visible: false,
      cv: null
    });
    _this.$log = $log;
    _this.$timeout = $timeout;
    _this.AccesoDatos = AccesoDatos;
    return _this;
  }
  _inherits(PanelCoincidenciasHistoricComponentCtrl, _BaseFeaturesComponen);
  return _createClass(PanelCoincidenciasHistoricComponentCtrl, [{
    key: "$onInit",
    value: function $onInit() {
      this.$log.info('[PanelCoincidenciasHistoricComponentCtrl] onInit');
    }
  }, {
    key: "buscarRelacionadosCv",
    value: function buscarRelacionadosCv() {
      var _this2 = this;
      this._callBackCoincidenciasCv(this.filtroHist.value) //
      .then(function (listadoRes) {
        // this.listado.list = listadoRes.cvList
        _this2.listado.valido = true;
      });
    }
  }, {
    key: "buscarRelacionadosLotes",
    value: function () {
      var _buscarRelacionadosLotes = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var cvs;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return this.AccesoDatos.GestionCurr_CLIENT.regsCV({
                num: this.filtroHist.nregs || 10,
                pag: this.filtroHist.npage || 0
              });
            case 1:
              cvs = _context.v;
              if (this.filtroHist.lote > 0) {
                this.buscarRelacionadosPorLote(cvs.content, this.filtroHist.lote, 'loteActual');
              }
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function buscarRelacionadosLotes() {
        return _buscarRelacionadosLotes.apply(this, arguments);
      }
      return buscarRelacionadosLotes;
    }()
  }, {
    key: "buscarRelacionadosPendLotes",
    value: function () {
      var _buscarRelacionadosPendLotes = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var cvs_content;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return this.AccesoDatos.HistoricCurr_CLIENT.regsCVPendientesHist();
            case 1:
              cvs_content = _context2.v;
              if (!this.filtroHist.noBuscarPend) {
                this.buscarRelacionadosPorLote(cvs_content, this.filtroHist.lotePend, 'lotePendActual');
              }
            case 2:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function buscarRelacionadosPendLotes() {
        return _buscarRelacionadosPendLotes.apply(this, arguments);
      }
      return buscarRelacionadosPendLotes;
    }()
  }, {
    key: "buscarRelacionadosPorLote",
    value: function () {
      var _buscarRelacionadosPorLote = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(list, lote, propLog) {
        var _this3 = this;
        var chunks, nlotes, $idx, _chunk, rel;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              // generar de 10 en 10 y procesarlos secuencialmente
              chunks = chunk(list, lote || 10);
              nlotes = chunks.length - 1;
              $idx = 0;
            case 1:
              if (!($idx < chunks.length)) {
                _context3.n = 4;
                break;
              }
              this[propLog] = " *** ".concat($idx, " / ").concat(nlotes, " *** ");
              _chunk = chunks[$idx];
              _context3.n = 2;
              return this.buscarRelacionados('CVS', _chunk.map(function (c) {
                return c.idcv;
              }) // los ids
              );
            case 2:
              rel = _context3.v;
              console.log('----> rel ', $idx);
            case 3:
              $idx++;
              _context3.n = 1;
              break;
            case 4:
              this.$timeout(function () {
                _this3[propLog] = ' *** finalizado ***';
              }, 500);
              this.$timeout(function () {
                _this3[propLog] = '';
              }, 2500);
            case 5:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function buscarRelacionadosPorLote(_x, _x2, _x3) {
        return _buscarRelacionadosPorLote.apply(this, arguments);
      }
      return buscarRelacionadosPorLote;
    }()
  }, {
    key: "buscarRelacionados",
    value: function () {
      var _buscarRelacionados = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(seleccion, idcvs) {
        var _f, listadoRes;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _f = {
                idsCv: [],
                limit: 1000,
                seleccion: seleccion
              };
              if (seleccion === 'CVS') {
                _f.idsCv = idcvs ? idcvs : this.filtroHist.value ? [Number(this.filtroHist.value)] : [];
              }
              if (!(seleccion === 'TODOS' || seleccion === 'PENDIENTES')) {
                _context4.n = 1;
                break;
              }
              if (confirm('Esto son demasiados!!!!  ¿seguir?')) {
                _context4.n = 1;
                break;
              }
              return _context4.a(2);
            case 1:
              _context4.n = 2;
              return this._callBackCoincidenciasSeleccion(_f);
            case 2:
              listadoRes = _context4.v;
              //

              // this.listado.list = listadoRes.cvList
              this.listado.valido = true;
              return _context4.a(2, listadoRes);
          }
        }, _callee4, this);
      }));
      function buscarRelacionados(_x4, _x5) {
        return _buscarRelacionados.apply(this, arguments);
      }
      return buscarRelacionados;
    }()
  }, {
    key: "_callBackCoincidenciasCv",
    value: function _callBackCoincidenciasCv(idcv) {
      return this.AccesoDatos.HistoricCurr_CLIENT.buscarHistoricosRelacionados(Number(idcv));
    }
  }, {
    key: "_callBackCoincidenciasSeleccion",
    value: function _callBackCoincidenciasSeleccion(pet) {
      return this.AccesoDatos.HistoricCurr_CLIENT.buscarCoincidenciasHistorico(pet);
    }
  }, {
    key: "accesscvhist",
    value: function accesscvhist(idx) {
      this.$log.debug('access', this.listado.list[idx]);
      this.panelcv.cv = this.listado.list[idx];
      this.panelcv.$visible = true;
    }
  }]);
}(BaseFeaturesComponent);
angular.module('candidato').component('panelCoincidenciasHistoric', {
  bindings: {},
  controller: PanelCoincidenciasHistoricComponentCtrl,
  // templateUrl: "panel-busqueda-historic.component.html",
  template: require('./panel-coincidencias-historic.component.html')
});